<template>
  <div class="error-404">
    <div class="error-404__content">
      <div class="main-container">
        <header class="error-404__header">
          <h1 class="heading">404</h1>
          <p class="paragraph">not found</p>
        </header>
        <main class="error-404__main">
          <h3 class="heading">The spark plugs from this car are missing.</h3>
          <p class="paragraph">
            You can go back to our
            <router-link :to="{ name: HOME_PAGE_NAME }">homepage</router-link>
            or try again later in a few minutes.
          </p>
        </main>
      </div>
    </div>
    <div class="error-404__credit-author">
      Screenshot by
      <a href="http://tatanko.imgur.com/" target="_blank">Tatanko</a>
    </div>
  </div>
</template>

<script>
import { HOME_PAGE_NAME } from "../router/pageNameConstants";

export default {
  data() {
    return {
      HOME_PAGE_NAME
    };
  },
  metaInfo: {
    title: "404 Not Found"
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/vars";
@import "../assets/styles/mixins";

.error-404 {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: #760a0e url("/public/img/errors/404.jpg") center no-repeat;
  background-size: cover;
  text-align: center;
  font-size: 14px;

  @media (max-width: $screen-lg-max) {
    background-image: url("/public/img/errors/404-xl.jpg");
    font-size: 12px;
  }

  @media (max-width: $screen-md-max) {
    background-image: url("/public/img/errors/404-lg.jpg");
  }

  @media (max-width: $screen-sm-max) {
    background-image: url("/public/img/errors/404-md.jpg");
    font-size: 10px;
  }

  @media (max-width: $screen-xs-max) {
    background-image: url("/public/img/errors/404-sm.jpg");
  }

  @media (max-width: $screen-xs) {
    background-image: url("/public/img/errors/404-xs.jpg");
  }

  &__content {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__header {
    font-size: 1em;
    position: relative;
    display: inline-block;
    margin: 0 0 em(35);
    font-family: $sarala;
    font-weight: 700;
    text-transform: uppercase;

    @media (max-width: $screen-xs-max) {
      font-size: 0.75em;
    }

    &::before,
    &::after {
      position: absolute;
      top: 0;
      font-size: em(250);
      line-height: 0.8;
      color: rgba(#f2f2f2, 0.59);
      vertical-align: top;

      @media (max-width: $screen-xs-max) {
        display: none;
      }
    }

    &::before {
      content: "[";
      left: -0.68em;
    }

    &::after {
      content: "]";
      right: -0.68em;
    }

    h1 {
      font-size: em(226);
      line-height: 0.7;
      letter-spacing: 0.03em;
    }

    p {
      font-size: em(70);
      letter-spacing: 0.05em;
    }
  }

  &__main {
    font-size: 1em;

    @media (max-width: $screen-xs) {
      font-size: 0.85em;
    }

    h3 {
      margin: 0 0 em(20, 35);
      font-size: em(35);
      letter-spacing: 0.06em;
    }

    p {
      margin: 0;
      font-size: em(23);
      letter-spacing: 0.05em;

      a {
        color: inherit;

        &:hover,
        &:focus {
          color: inherit;
        }
      }
    }
  }

  &__credit-author {
    position: absolute;
    right: 1em;
    bottom: 1em;
    font-size: em(18);

    a {
      color: $mainRed;
      text-decoration: underline;
    }
  }
}
</style>
